import { render, staticRenderFns } from "./RebateTemplateUpload.vue?vue&type=template&id=2320d0ae&scoped=true"
import script from "./RebateTemplateUpload.vue?vue&type=script&lang=js"
export * from "./RebateTemplateUpload.vue?vue&type=script&lang=js"
import style0 from "./RebateTemplateUpload.vue?vue&type=style&index=0&id=2320d0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320d0ae",
  null
  
)

export default component.exports